export default __webpack_public_path__ + "static/media/oturma.023d0e1c.jpg";